import { useState, useEffect } from 'react';
import { isEqual } from 'underscore';

export function useStableObject(obj) {
  const [stableObj, setStableObject] = useState(null);

  useEffect(() => {
    if (!isEqual(obj, stableObj)) {
      setStableObject(obj);
    }
  }, [obj, stableObj]);
  return stableObj || obj;
}
